/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IDashboardOutputFavorite,
  IDashboardOutputWompStats,
  IDashboardOutputArchived,
  IDashboardOutputProjectInfo,
  IDashboardOutputProjectsForNavigation,
  ILastUpdatedEpochTime,
  IDashboardOutputPinnedItems,
  IGenericJSONMessage,
} from '../types/response.types'

export default new class DashboardAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_Favorites(
  ): Promise<IDashboardOutputFavorite[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/dashboard/favorites`,
    })
  }
  public async get_WompStats(
  ): Promise<IDashboardOutputWompStats> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/dashboard/womp-stats`,
    })
  }
  public async get_Archived(
  ): Promise<IDashboardOutputArchived> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/dashboard/archived`,
    })
  }
  public async get_ProjectInfo(
  ): Promise<IDashboardOutputProjectInfo> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/dashboard/project-info`,
    })
  }
  public async get_ProjectsForNavigation(
  ): Promise<IDashboardOutputProjectsForNavigation> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/dashboard/projects-for-navigation`,
    })
  }
  public async get_MostRecentLastUpdatedProjectEpochTime(
  ): Promise<ILastUpdatedEpochTime> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/dashboard/most-recent-last-updated-project-epoch-time`,
    })
  }
  public async get_PinnedItems(
  ): Promise<IDashboardOutputPinnedItems> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/dashboard/pinned-items`,
    })
  }
  /****** POST methods *****/
  public async post_AddPinnedItem(
    itemID: number,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/dashboard/pinned-items`,
      data: {
        itemID
      },
    })
  }
  /****** DELETE methods *****/
  public async delete_DeletePinnedItem(
    item_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/dashboard/pinned-items/${item_id}`,
    })
  }
}()
